<template>
  <nav>
    <ul
      class="flex gap-x-8 font-sans xs:gap-x-0 xs:border-y xs:border-gray-300 xs:pb-0 lg:gap-x-12 lg:border-y-0"
    >
      <li
        v-for="item in genderMenuItems"
        :key="item.key"
        :class="[
          // Mobile styles
          'z-10 m-0 flex h-[54px] flex-1 items-center justify-center border-r border-gray-300 last:border-r-0 xs:px-2 xs:py-4',

          // Desktop overrides
          'lg:m-0 lg:h-auto lg:flex-initial lg:justify-start lg:border-0 lg:p-0',
        ]"
      >
        <SFLocalizedLink
          :to="`/${normalizeWithoutSpecialCharacters(
            item.label.toLowerCase(),
          )}`"
          :class="[
            // Mobile centering
            '!md:p-0 !xs:p-4 flex size-full items-center justify-center text-center  !font-sans text-xl !font-normal focus:outline-none xs:font-sans xs:text-lg xs:hover:text-anthracite-800 md:font-sans md:hover:text-orange-500',
            isActive(formatGender(item.label))
              ? 'decoration-2 underline-offset-4  xs:text-anthracite-800 xs:underline md:text-orange-500 md:no-underline'
              : 'text-anthracite-800',
            // Desktop overrides
            'lg:block lg:size-auto lg:items-start lg:justify-start lg:text-md',
          ]"
        >
          {{ item.label }}
        </SFLocalizedLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import {
  normalizeToCamelCase,
  normalizeWithoutSpecialCharacters,
} from '~/utils/stringNormalize'
import SFLocalizedLink from '~/components/SFLocalizedLink.vue'
import { useTopNavigationMenu } from '~/composables/useTopNavigationMenu'
import { useGenderMenuItems } from '~/composables/useGenderMenuItems'

const { currentMenu } = useTopNavigationMenu()

const { genderMenuItems } = useGenderMenuItems()

const formatGender = (key: string) =>
  normalizeWithoutSpecialCharacters(normalizeToCamelCase(key))

const isMounted = ref(false) // workaround to avoid hydration error

const isActive = (item: string) =>
  isMounted.value ? currentMenu.value === item : false // avoid hydration error on SSR

/**
 * This is a workaround to avoid hydration error on SSR,
 * because an up to date version of currentMenu is not available on SSR at moment, caused by cloudflare.
 */
onMounted(() => {
  isMounted.value = true
})

defineOptions({
  name: 'SFHeaderTopNavigation',
})
</script>
